import Image from 'next/image';
import { PortableText } from '@portabletext/react';
import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { getSanityImageUrl } from '@/libs/sanity/client';
import { PortableTextWrapper } from './PortableTextWrapper';

type LeftImageRightTextProps = {
  anchor?: string;
  image: any;
  rightContent:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
};

const LeftImageRightText = ({
  anchor,
  image,
  rightContent,
}: LeftImageRightTextProps) => {
  return (
    <section
      id={anchor}
      className="max-w-8xl mx-auto flex flex-col lg:flex-row justify-center gap-x-8 mt-4 scroll-mt-[150px]"
    >
      <div className="w-full lg:w-1/2 relative">
        <Image
          src={getSanityImageUrl(image)}
          alt="Image"
          className="h-full object-cover w-full"
          loading="lazy"
          fill={true}
        />
      </div>
      <div className="w-full lg:w-1/2 [&>p]:mb-4 text-lg ">
        {rightContent && <PortableTextWrapper value={rightContent} />}
      </div>
    </section>
  );
};
export default LeftImageRightText;
